import { Component, h } from '@stencil/core';

@Component({
  tag: 'dynamic-skeleton-loading-container',
  styleUrl: 'dynamic-skeleton-loading-container.css',
})
export class DynamicSkeletonLoadingContainer {
  render() {
    return (
      <div class="dynamic-skeleton-loader-container">
        <div class="flex">
          <skeleton-rect class="w-1/5 mr-3"></skeleton-rect>
          <skeleton-rect class="w-1/5 mr-3"></skeleton-rect>
          <skeleton-rect class="w-1/5 mr-3"></skeleton-rect>
        </div>
        <dynamic-skeleton-loading useMiddleRow={true} />
        <div class="mt-3 flex">
          <skeleton-image class="mr-2"></skeleton-image>
          <div class="w-full flex flex-col gap-y-2">
            <skeleton-rect class="w-full" height="xs" borderRadius="rounded-sm"></skeleton-rect>
            <skeleton-rect class="w-full" height="xs" borderRadius="rounded-sm"></skeleton-rect>
          </div>
        </div>
      </div>
    );
  }
}
